<template>
  <blockquote>
    <p>
      identyfikator wyexportowanego zip'a:
      {{ form.tasks_data['CREATE_ZIP']['input']['exported_svg_id'] }}
    </p>
  </blockquote>
</template>
<script>
export default {
  props: ['form']
}
</script>
